import.meta.glob(['../images/**', '../fonts/**']);

import { motion } from './modules/motion';
import { map } from './modules/map';
import { nav } from './modules/nav';
import { form } from './modules/form';

import Alpine from 'alpinejs';
import anchor from '@alpinejs/anchor';
import overlap from 'alpinejs-overlap';

import Glider from 'glider-js';

Alpine.plugin(overlap);
Alpine.plugin(anchor);
Alpine.start();

motion();
map();
nav();
form();

function autoplay(slider, miliseconds) {
  const slidesCount = slider.track.childElementCount;
  let slideTimeout = null;
  let nextIndex = 1;

  function slide() {
    slideTimeout = setTimeout(function () {
      if (nextIndex >= slidesCount) {
        nextIndex = 0;
      }
      slider.scrollItem(nextIndex++);
    }, miliseconds);
  }

  slider.ele.addEventListener('glider-animated', function () {
    window.clearInterval(slideTimeout);
    slide();
  });

  slide();
}

if (document.getElementsByClassName('masthead-carousel').length) {
  const gliders = document.querySelectorAll('.masthead-carousel');

  gliders.forEach(function (ele) {
    let mGlider = new Glider(ele, {
      slidesToShow: 1,
      slidesToScroll: 1,
      draggable: true,
      scrollLock: true,
      dots: ele.parentNode?.querySelector('.dots'),
      duration: 1,
    });

    autoplay(mGlider, 6000);
  });
}

if (document.getElementsByClassName('carousel-narrow').length) {
  const gliders = document.querySelectorAll('.carousel-narrow');

  gliders.forEach(function (ele) {
    new Glider(ele, {
      slidesToShow: 1.2,
      slidesToScroll: 1,
      draggable: true,
      scrollLock: true,
    });
  });
}

let querystring = new URLSearchParams(window.location.search).toString();

if (querystring.length > 0) {
  if (querystring.startsWith('?')) {
    querystring = querystring.replace('?', '');
  }

  for (let a of document.querySelectorAll('a')) {
    a.href += (a.href.match(/\?/) ? '&' : '?') + querystring;
  }
}

var scrollHandler = null;

function autoScroll() {
  let index = 1;
  let left = 0;
  clearInterval(scrollHandler);
  scrollHandler = setInterval(function () {
    if ( document.getElementById('stat' + index) !== null) {

    let width = document.getElementById('stat' + index).offsetWidth;
    let stats = document.querySelectorAll('.stat');
    
    if (index !== 0) {
      left += width;
    } else {
      left = 0;
    }

    document
      .getElementById('stats')
      .scrollTo({ left: left, top: 0, behavior: 'smooth' });

    index++;

    if (stats.length == index) {
      index = 0;
    }
  }
  }, 5000);
}

autoScroll();
